module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexAbouts"
    }
  }, [_c('section', {
    staticClass: "sub--header diagonal-shadow mg-bottom-diagonal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAbout us\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime voluptatem, fugit laboriosam assumenda?\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'apply-project'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t  Konsultasikan pada kami\n\t\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "section--wrapper bg-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.about_us) ? _c('div', {
    staticClass: "box-information"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.about_us.title) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.about_us.short_desc) + "\n\t\t\t\t\t\t\t\t")])])]) : _vm._e()])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('section', {
    staticClass: "section--wrapper about-us"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.team), function(t) {
    return _c('div', {
      key: t.name,
      staticClass: "box-list-team"
    }, [_c('div', {
      staticClass: "box-list-team__image"
    }, [_c('img', {
      attrs: {
        "src": t.foto_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "box-list-team__name"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(t.name) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "box-list-team__position"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(t.position) + "\n\t\t\t\t\t\t\t")])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCOMPANY PROFILE DOWNLOAD\n\t\t\t\t\t\t\t")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title txt-white"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPerkenalkan Team Kami\n\t\t\t\t\t\t\t")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bf0ed81","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/aboutus/IndexAboutus.vue
// module id = 80
// module chunks = 0